import { Button } from 'antd';
import useConfig from '../../core/modules/book/hooks/useConfig.query';
import { TABLEAU_AUTHOR_DETAILS_LINK_URL } from '../../core/constants/global-constants';
import OpenInNewTabIcon from '../../assets/icons/open-in-new-tab-white.svg';
import './AuthorRelationship/author-relationship.css';

// "/t/<site>/views/" -> "/#/site/<site>/views/". No-op if already browser form.
const toBrowserUrl = (embedUrl: string): string =>
  embedUrl.replace(/\/t\/([^/]+)\/views\//, '/#/site/$1/views/');

const OverlayTableauLink = ({ authorName }: { authorName?: string }) => {
  const { data: config } = useConfig();

  const configuredUrl = config?.tableau?.author_performance_view_url;
  const baseUrl = configuredUrl
    ? toBrowserUrl(configuredUrl)
    : TABLEAU_AUTHOR_DETAILS_LINK_URL;

  const href = authorName
    ? `${baseUrl}?Author=${encodeURIComponent(authorName)}`
    : baseUrl;

  return (
    <Button
      className='ar-green-button'
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      style={{ marginTop: 20 }}
    >
      More author details on Tableau
      <img src={OpenInNewTabIcon} alt='Open in new tab' className='ar-green-button-icon' />
    </Button>
  );
};

export default OverlayTableauLink;
